import Swiper from 'swiper';

export default function () {
    setTimeout(function () {
        const productdetailswiper = document.getElementById('productdetailswiper');
        const productdetailthumbsswiper = document.getElementById('productdetailthumbsswiper');
        if (productdetailswiper && productdetailthumbsswiper) {
            const myswiper = new Swiper('#productdetailthumbsswiper', {
                spaceBetween: 10,
                slidesPerView: 3,
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                breakpoints: {
                    992: {
                        slidesPerView: 3
                    },
                    1280: {
                        slidesPerView: 4
                    }
                }
            });

            new Swiper('#productdetailswiper', {
                spaceBetween: 0,
                navigation: {
                    nextEl: '#productdetailswiper__next',
                    prevEl: '#productdetailswiper__prev'
                },
                thumbs: {
                    swiper: myswiper
                }
            });
        }

        const actionitems = document.getElementsByClassName('c-actions__items swiper-container');
        if (actionitems.length > 0) {
            new Swiper('.c-actions__items.swiper-container', {
                spaceBetween: 20,
                slidesOffsetBefore: 20,
                slidesOffsetAfter: 20,
                slidesPerView: 'auto',
                freeMode: true,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                watchOverflow: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                breakpoints: {
                    768: {
                        slidesPerGroup: 2,
                        slidesPerView: 2,
                        spaceBetween: 0,
                        slidesOffsetBefore: 0,
                        slidesOffsetAfter: 0
                    }
                }
            });
        }

		const linkcardsitems = document.getElementsByClassName('c-lc__items swiper-container');
        if (linkcardsitems.length > 0) {
			new Swiper('.c-lc__items.swiper-container', {
                spaceBetween: 0,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                slidesPerView: 1,
                slidesPerGroup: 1,
                freeMode: false,
                watchSlidesVisibility: true,
                watchSlidesProgress: true,
                watchOverflow: true,
                pagination: false,
                navigation: {
					nextEl: '.c-lc__nav--next',
                    prevEl: '.c-lc__nav--prev'
                },
                breakpoints: {
                    992: {
                        slidesPerGroup: 2,
                        slidesPerView: 2
                    }
                }
            });
        }

        const homereferencesitems = document.getElementsByClassName('c-refs__items swiper-container');
        if (homereferencesitems.length > 0) {
			new Swiper('.c-refs__items.swiper-container', {
                slidesPerView: 1,
                pagination: false,
                speed: 600,
                parallax: true,
                effect: 'fade',
                fadeEffect: {
                    crossFade: true
                },
                navigation: {
					nextEl: '.c-refs__nav--next',
                    prevEl: '.c-refs__nav--prev'
                },
                loop: true
            });
        }
    }, 500);
}
